import * as React from 'react'
import { Box } from '@ally/metronome-ui'
import { AdobeTile, AdobeTileContent } from '../../types'
import MdSmTile from './MdSmTile'

interface TileGroupProps {
  data: AdobeTileContent
}

const MdSmTileGroup: React.FC<TileGroupProps> = ({ data }) => {
  // Limit tiles to render to 3
  const tiles = data.tiles.slice(0, 3)

  return (
    <Box
      display="flex"
      flexDirection="row"
      flexGrow={1}
      justifyContent="space-evenly"
    >
      {tiles.map((tileData: AdobeTile, index) => {
        const tileDataKey = `explore-tile-${index}`
        return <MdSmTile tileData={tileData} key={tileDataKey} />
      })}
    </Box>
  )
}

export default MdSmTileGroup
